import merge from 'lodash-es/merge';

import { STATUSES } from '@/constants';
import { ProductInventory } from '@/models/inventory';
import { Product } from '@/models/product';

import sortItems from './sortItems';

/**
 * Sort products for OrderInformation product select
 * We want to have 2 sorted lists split by availability.
 * Products with 0 available inventory should be listed at the bottom.
 * NOTE: we're sorting on the frontend because we know the availableInventory and displayName (already
 * translated etc.), while on the backend these values need to be "calculated" first and it's problematic.
 */
export default function sortByAvailability({
  products,
  additionalProperties,
}: {
  products: (Product | ProductInventory)[];
  additionalProperties?: Partial<Product> & { selected?: boolean };
}) {
  let availableProducts: (Product | ProductInventory)[] = [];
  let unavailableProducts: (Product | ProductInventory)[] = [];

  products.forEach((product) => {
    const hasAvailableInventory = typeof product.availableInventory === 'number' && product.availableInventory > 0;
    const isInventoryManagementUnlimited = product.inventoryManagement === STATUSES.INVENTORY_MANAGEMENT.UNLIMITED;

    if (hasAvailableInventory || isInventoryManagementUnlimited) {
      availableProducts.push(product);
    } else {
      unavailableProducts.push(product);
    }
  });

  availableProducts = sortItems(availableProducts, { sortBy: 'displayName' });
  unavailableProducts = sortItems(unavailableProducts, { sortBy: 'displayName' });

  let sortedProducts = availableProducts.concat(unavailableProducts);

  if (additionalProperties) {
    sortedProducts = sortedProducts.map((product) => {
      return merge({}, product, additionalProperties);
    });
  }

  return sortedProducts;
}
